import styled from 'styled-components';

const addOverFlowAuto = height => {
  if (height > 0) {
    return `
      height: ${height}px;
      overflow: auto;
    `;
  }
  return ``;
};

const ItemList = styled.div`
  ${props => addOverFlowAuto(props.height)} /* eslint-disable-line */
  table tbody tr td {
    &:hover {
      cursor: pointer;
    }
  }
  .OAuthCell {
    .LoggedInWith {
      p {
        margin: 0;
        color: #000;
      }

      .ServiceIcon {
        float: left;
        width: auto;
        margin-right: 15px;
        i {
          font-size: 20px;
        }
      }
      &.facebook {
        color: $facebook;
      }

      &.google {
        color: $google;
      }
    }
  }
`;

export default { ItemList };
